import Footer from '../components/Footer';
import GenresGrid from '../components/GenresGrid';
import HorizontalScrollArtists from '../components/HorizontalScrollArtists';
import HorizontalScrollMediaView from '../components/HorizontalScrollMediaView';
import SectionHeader from '../components/SectionHeader';
import { getPopularAlbumsBySearchCount } from '../data/albums';
import { getPopularArtistsBySearchCount } from '../data/artists';
import { getPopularGenresBySearchCount } from '../data/musicGenres';
import { getPopularSinglesBySearchCount } from '../data/singles';

const Search = () => {

  document.title = "Search";
  
  const popularSearchedSingles = getPopularSinglesBySearchCount();
  const popularSearchedAlbums = getPopularAlbumsBySearchCount();
  const popularSearchedArtists = getPopularArtistsBySearchCount();
  const popularSearchedGenres = getPopularGenresBySearchCount();

  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20 min-h-screen">
      <HorizontalScrollArtists
        artists={popularSearchedArtists}
        headTitle={"Most Searched Artists"}
      />
      <HorizontalScrollMediaView
        collection={popularSearchedAlbums}
        headTitle={"Trending Albums"}
      />
      <HorizontalScrollMediaView
        collection={popularSearchedSingles}
        headTitle={"Popular Singles"}
      />
      <SectionHeader title="Explore Trending Genres" />
      <GenresGrid collection={popularSearchedGenres} />
      <Footer />
    </div>
  );
};

export default Search;